var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import IoDown from "react-icons/lib/io/ios-arrow-down";
import IoRight from "react-icons/lib/io/ios-arrow-right";
import MD from "@irati/ui/src/Markdown";
import { Label, H6 } from "@irati/ui/src/Typography";
import ListItem from "./styled/ListItem";
import ExpandIcon from "./styled/ExpandIcon";
import ItemTopWrapper from "./styled/ItemTopWrapper";
var ExpandingListItem = /** @class */ (function (_super) {
    __extends(ExpandingListItem, _super);
    function ExpandingListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        _this.doToggle = function () {
            _this.setState({ isOpen: !_this.state.isOpen });
        };
        return _this;
    }
    ExpandingListItem.prototype.render = function () {
        var _a = this.props.item, title = _a.title, description = _a.description;
        var isOpen = this.state.isOpen;
        return (React.createElement(ListItem, { direction: "column" },
            React.createElement(ItemTopWrapper, { alignItems: "center", onClick: this.doToggle },
                React.createElement(ExpandIcon, { large: true }, isOpen ? React.createElement(IoDown, { "data-test": "icon-down" }) : React.createElement(IoRight, { "data-test": "icon-down" })),
                React.createElement(H6, { marginLeft: 2, padding: [0.5, 0] }, title)),
            React.createElement(Label, { large: true, marginLeft: 7 }, isOpen && React.createElement(MD, { source: description }))));
    };
    return ExpandingListItem;
}(Component));
export default ExpandingListItem;
